import { useMedia } from '@/hooks/useMedia/useMedia';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import { Box, Button, IconButton, Skeleton, Stack, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ClassroomSettings } from '../../../types/session';

function FullscreenIconButton({ onClick }: { onClick?: () => void }) {
    const { t } = useTranslation();

    return (
        <Tooltip title={t('classroom.actions.fullscreen')}>
            <IconButton onClick={onClick}>
                <FullscreenIcon />
            </IconButton>
        </Tooltip>
    );
}

export const ClassroomScreenControl = ({ settings, onScreenSync, onFullScreen }: { settings?: ClassroomSettings; onScreenSync?: (checked: boolean) => void; onFullScreen?: () => void }) => {
    const { t } = useTranslation();
    const { isMobile } = useMedia();

    return (
        <Box
            sx={{
                m: 2,
                mb: 0,
            }}
        >
            {!settings ? (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} data-testid='sync-control-skeleton'>
                    <Skeleton variant='rounded' height={40} width={160} />
                </Box>
            ) : settings?.screenSync ? (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                    <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
                        <PresentToAllIcon color='success' />
                        <Typography color='text.primary'>{t('classroom.label.screenSync')}</Typography>
                    </Stack>
                    <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
                        <FullscreenIconButton onClick={onFullScreen} />
                        <Button startIcon={isMobile ? undefined : <CancelPresentationIcon color='info' />} variant='outlined' onClick={() => onScreenSync?.(false)} sx={{ color: 'text.primary' }}>
                            {isMobile ? <CancelPresentationIcon color='info' /> : t('classroom.actions.stopScreenSync')}
                        </Button>
                    </Stack>
                </Box>
            ) : (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
                        <FullscreenIconButton onClick={onFullScreen} />
                        <Button startIcon={isMobile ? undefined : <PresentToAllIcon color='success' />} variant='contained' onClick={() => onScreenSync?.(true)}>
                            {isMobile ? <PresentToAllIcon color='success' /> : t('classroom.actions.screenSync')}
                        </Button>
                    </Stack>
                </Box>
            )}
        </Box>
    );
};
